import { RankMethod } from '../shared/enums/rank-method';

interface NbaDivisionWinnerStateTeam {
  IsDivisionWinner?: KnockoutObservable<boolean>;
  RankMethod: KnockoutObservable<RankMethod>;
}

export function getNbaDivisionWinnerState(team: NbaDivisionWinnerStateTeam): boolean {
  const explicitState = team.IsDivisionWinner?.();
  if (explicitState != null) {
    return explicitState;
  }

  const rankMethod = team.RankMethod();
  return (
    rankMethod === RankMethod.DivisionWinner ||
    rankMethod === RankMethod.DivisionWinnerCoinFlip ||
    rankMethod === RankMethod.DivisionWinnerMultiWay
  );
}
